import { ToggleButtonGroup, ToggleButton } from "@mui/material";
import { useI18n } from "../i18n/I18nProvider";

export default function LanguageSwitcher() {
  const { lang, setLang, t } = useI18n();

  return (
    <ToggleButtonGroup
      size="small"
      exclusive
      value={lang}
      onChange={(_, next) => {
        if (next) setLang(next);
      }}
      sx={{
        bgcolor: "#FFFFFFB3",
        border: "1px solid #00000014",
        borderRadius: 999,
        overflow: "hidden",
        "& .MuiToggleButton-root": {
          px: 1.1,
          py: 0.45,
          fontWeight: 900,
          textTransform: "none",
          border: 0,
          color: "#111827B3",
        },
        "& .Mui-selected": {
          color: "#111827",
          bgcolor: "#11182712",
        },
      }}
    >
      <ToggleButton value="en">{t("lang.en")}</ToggleButton>
      <ToggleButton value="de">{t("lang.de")}</ToggleButton>
    </ToggleButtonGroup>
  );
}